import { Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { VendorManagementComponent } from './pages/vendor-management/vendor-management.component';
import { FaqComponent } from './pages/faq/faq.component';
import { AdminHubComponent } from './pages/admin-hub/admin-hub.component';
import { SideMenuComponent } from './components/navbars/side-menu/side-menu.component';
import { LoginComponent } from './pages/login/login.component';
import { NavbarComponent } from './components/navbars/navbar/navbar.component';
import { AuthGuard } from './Auth/auth.guard';
import { ProfilePageComponent } from './pages/profile-page/profile-page.component';
import { ViewFormPageComponent } from './pages/view-form-page/view-form-page.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { StartFormComponent } from './pages/start-form/start-form.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { SignupOrLoginComponent } from './pages/signup-or-login/signup-or-login.component';
import { VendorMessagesComponent } from './pages/vendor-messages/vendor-messages.component';
import { ADMIN_ROLES } from './roles';

export const routes: Routes = [
    { path: 'admin', component: AdminHubComponent, canActivate: [AuthGuard], data: { roles: [...ADMIN_ROLES] } },
    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], data: { roles: [...ADMIN_ROLES] } },
    // { path: 'navbar', component: NavbarComponent },
    { path: '', component: SignupOrLoginComponent},
    {path: 'login', component: LoginComponent},
    { path: 'accounts', component: VendorManagementComponent, canActivate: [AuthGuard], data: { roles: [...ADMIN_ROLES] } },
    {
      path: 'vendor-submissions',
      canActivate: [AuthGuard],
      data: { roles: [...ADMIN_ROLES] },
      loadChildren: () =>
        import('./pages/vendor-submissions/vendor-submissions.routes').then((m) => m.default),
    },
    { path: 'profile', component: ProfilePageComponent, canActivate: [AuthGuard] },
    { path: 'registrationform', component: ViewFormPageComponent, canActivate: [AuthGuard], data: { roles: ['Vendor'] }},
    { path: 'messages', component: VendorMessagesComponent, canActivate: [AuthGuard], data: { roles: ['Vendor'] } },
    { path: 'registrationform/:id', component: ViewFormPageComponent, canActivate: [AuthGuard], data: { roles: [...ADMIN_ROLES] } },
    { path: 'faq', component: FaqComponent, canActivate: [AuthGuard] },
    { path: 'sidenav', component: SideMenuComponent, canActivate: [AuthGuard] },
    { path: 'start', component: StartFormComponent, canActivate: [AuthGuard], data: { roles: ['Guest'] }},
    { path: 'reset_password', component: ResetPasswordComponent},
    { path: 'unauthorized', component: UnauthorizedComponent },

    { path: '**', redirectTo: '/' }
  ];